import { useState } from "react";
import type { ReactNode } from "react";
import type { Crumb } from "@/components/base/Breadcrumb";
import PageHeader from "@/components/feature/PageHeader";

type CategoryPageProps = {
  breadcrumb: Crumb[];
  kicker: string;
  title: string;
  description: string;
  meta?: ReactNode;
  filterContent: ReactNode;
  count: number;
  onReset: () => void;
  children: ReactNode;
};

export default function CategoryPage({
  breadcrumb,
  kicker,
  title,
  description,
  meta,
  filterContent,
  count,
  onReset,
  children,
}: CategoryPageProps) {
  const [filtersOpen, setFiltersOpen] = useState(false);

  return (
    <>
      <PageHeader breadcrumb={breadcrumb} kicker={kicker} title={title} description={description} meta={meta} />
      <div className="w-full px-4 md:px-6 lg:px-10 py-6 md:py-10">
        <div className="grid grid-cols-1 lg:grid-cols-[230px_minmax(0,1fr)] gap-5 lg:gap-8">
          <aside className="lg:sticky lg:top-24 h-fit">
            <button
              type="button"
              onClick={() => setFiltersOpen((prev) => !prev)}
              aria-expanded={filtersOpen}
              className="lg:hidden w-full flex items-center justify-between gap-2 rounded-md border border-background-300 bg-background-50 px-3.5 py-3 text-sm text-foreground-800 cursor-pointer"
            >
              <span className="flex items-center gap-2">
                <i className="ri-filter-3-line text-primary-600"></i>
                筛选与排序
              </span>
              <i className={`${filtersOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} text-foreground-400`}></i>
            </button>
            <div
              className={`${filtersOpen ? "block" : "hidden"} lg:block mt-3 lg:mt-0 rounded-lg border border-background-200 bg-background-50 p-4`}
            >
              <div className="hidden lg:flex items-center justify-between mb-4">
                <h2 className="text-sm font-semibold text-foreground-900">筛选条件</h2>
                <i className="ri-filter-3-line text-foreground-400"></i>
              </div>
              <div className="flex flex-col gap-5">{filterContent}</div>
              <button
                type="button"
                onClick={onReset}
                className="mt-5 w-full flex items-center justify-center gap-1.5 rounded-md border border-background-300 px-3 py-2 text-xs text-foreground-600 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-refresh-line"></i>
                重置筛选条件
              </button>
            </div>
          </aside>

          <div className="min-w-0">
            <div className="flex items-center justify-between gap-3 mb-4">
              <p className="text-xs md:text-sm text-foreground-500">
                共找到 <span className="text-foreground-900 font-medium">{count}</span> 条内容
              </p>
              <span className="text-[11px] text-foreground-400 hidden sm:inline">数据为演示内容，每日同步更新</span>
            </div>
            {children}
          </div>
        </div>
      </div>
    </>
  );
}